var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-maps"},[_c('div',{ref:"map",attrs:{"id":"map"}}),_c('div',{staticClass:"hidden"},[_c('icon-location-filled',{ref:"svgIcon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }